@if (isLoginPage()) {
  <div class="login-layout">
    <router-outlet></router-outlet>
  </div>
}
@if (!isLoginPage()) {
  <div id="main" class="layout-container" [class.layout-is-mobile]="viewState.isSmallish">
    @if (!isLoginPage() && !hideFraming) {
      <div id="navbar" style="width: 100%" data-test="navbar">
        <!-- default to alertsense brand banners if no theme is found -->
        <app-layout-banner></app-layout-banner>
        @if (!hideFraming) {
          <mat-toolbar class="mat-elevation-z4" [style.background-color]="primaryColor" [style.color]="secondaryColor">
            <button
              mat-icon-button
              id="menu-button"
              (click)="navDrawer.toggle()"
              [attr.aria-label]="(navDrawer?.opened ?? drawerOpenInitial) ? 'Collapse menu' : 'Expand menu'">
              <mat-icon>menu</mat-icon>
            </button>
            <a
              id="brand-logo-browser"
              class="brand-logo desktop-only"
              routerLink="/"
              routerLinkActive="active"
              [style.background-image]="logoUri"
              [style.background-color]="primaryColor"
              aria-label="Home"></a>
            @if (!!currentPage) {
              <div class="as-topnav-title" [id]="currentPage" longPress (longPress)="onTitleLongPress()">
                {{ currentPage | translate: locale.language }}
              </div>
            }
            <span class="toolbar-spacer"></span>
            <app-mock-selector></app-mock-selector>
            @if (isBetaUx) {
              <button mat-button id="leave-beta" (click)="leaveBeta()">
                <mat-icon>exit_to_app</mat-icon>
                <span class="menu-label">Exit Beta</span>
              </button>
            }
            <button mat-icon-button id="feedback-button" (click)="showFeedback()" aria-label="Send feedback">
              <mat-icon>flag</mat-icon>
            </button>
            <button mat-button id="support-button" [matMenuTriggerFor]="supportMenu" style="color: white">
              <mat-icon>help</mat-icon>
              <span class="menu-label">{{ 'Support' | translate: locale.language }}</span>
            </button>
            <mat-menu #supportMenu="matMenu" xPosition="before" yPosition="below">
              @for (link of supportInfo?.links; track $index) {
                <a [href]="link.url" [target]="link.newTab ? '_blank' : '_self'" mat-menu-item>{{
                  link.text | translate: locale.language
                }}</a>
              }
              <button [matMenuTriggerFor]="supportToolsMenu" mat-menu-item>
                {{ 'Support Tools' | translate: locale.language }}
              </button>
            </mat-menu>
            <mat-menu #supportToolsMenu="matMenu" xPosition="before" yPosition="below">
              <button mat-menu-item (click)="onViewAuthLog()">
                {{ 'Authentication Log' | translate: locale.language }}
              </button>
            </mat-menu>
            <app-account-menu [user]="user"></app-account-menu>
          </mat-toolbar>
        }
      </div>
    }
    <mat-sidenav-container id="sidenav-container" data-test="sidenav-container" class="layout-sidenav-container" autosize>
      @if (!hideFraming) {
        <mat-sidenav
          #navDrawer
          data-test="sidenav-drawer"
          [mode]="viewState.isSmallish ? 'over' : 'side'"
          [opened]="drawerOpenInitial"
          role="directory"
          fixedInViewport="true"
          [fixedTopGap]="toolbarHeight">
          <div id="lazy-loading">
            @if (loadingRouteConfig || !user) {
              <app-loading [isCircle]="false"></app-loading>
            }
          </div>
          @if (user) {
            <mat-nav-list id="nav-menu" data-test="sidenav-menu-list">
              <div
                class="brand-logo mobile-only"
                style="width: 100%"
                [style.background-image]="logoUri"
                [style.background-color]="primaryColor">
                <a mat-list-item id="brand-logo-mobile" title="Konexus" routerLink="/" (click)="onRouteClick()"></a>
              </div>
              @for (element of navElements; track $index) {
                <app-nav-element [element]="element" [level]="0"></app-nav-element>
              }
              <p class="mat-list-item-header">&nbsp;</p>
            </mat-nav-list>
          }
        </mat-sidenav>
      }
      <mat-sidenav-content id="main-content" class="content" role="main" [style.margin-top.px]="toolbarHeight">
        <app-full-page-loading></app-full-page-loading>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}
